import { Component, OnInit } from '@angular/core';
import { Consulta } from 'src/app/models/consulta';
import { Insumo } from 'src/app/models/insumo';
import { ConsultaComposta } from 'src/app/models/consulta-composta';
import { ConsultaService } from 'src/app/services/http/consulta.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalMsgService } from 'src/app/services/modal-msg.service';
import { UtilMasks } from 'src/app/utils/util-masks';
import { Router, ActivatedRoute } from '@angular/router';
import { TabelaPrecoService } from 'src/app/services/http/tabela-preco.service';
import { first } from 'rxjs/operators';
import { forkJoin } from 'rxjs';
import { Utils } from 'src/app/utils/utils';
import { CiacService } from 'src/app/services/http/ciac.service';
import { UtilValidators } from 'src/app/utils/util-validators';

@Component({
  selector: 'app-form-tabela-preco',
  templateUrl: './form-tabela-preco.component.html',
  styleUrls: ['./form-tabela-preco.component.scss']
})


export class FormTabelaPrecoComponent implements OnInit {

  uuid: number = null;
  listaConsulta: { cortesia: boolean, consulta: Consulta, range: FormGroup[] }[] = [];
  listaConsultaCombinada: { cortesia: boolean, consulta: ConsultaComposta, range: FormGroup[] }[] = [];
  listaCombos: { cortesia: boolean, nome: string, consultas: any, range: FormGroup[], id: any }[] = [];
  listaConsultaCombo: Consulta[] = [];
  listaConsultaCreditoCombo: Consulta[] = [];
  listaConsultaCredito: { cortesia: boolean, consulta: Consulta, range: FormGroup[] }[] = [];
  listaInsumoConsultas: { cortesia: boolean, insumo: Insumo, range: FormGroup[] }[] = [];
  modalForm;
  listaCombosCredito = [];
  listaCombos2: { nome: string, consultas: any, range: FormGroup[], id: any }[] = [];
  desativarInputsEBotoes: boolean = false;

  masks = {
    moeda: { mask: UtilMasks.moeda, gruide: false }
  }

  form = new FormGroup({
    nome: new FormControl('', [Validators.required]),
    descricao: new FormControl('', [Validators.required]),
    min: new FormControl('', [Validators.required]),
    intervalo: new FormControl('', [Validators.required]),
  });
  tabelaPadrao: boolean;
  exibirBotaoRefresh:boolean = false;

  constructor(
    private router: Router,
    private activedRoute: ActivatedRoute,
    private modalService: NgbModal,
    private msgModal: ModalMsgService,
    private tabelaPrecoService: TabelaPrecoService,
    private consultaService: ConsultaService,
    private ciacService: CiacService) {
    this.activedRoute.params.pipe(first()).subscribe(r => this.uuid = r.uuid || null);
    this.tabelaPadrao = this.activedRoute.snapshot.data.padrao;
    try{
      if ( this.activedRoute.snapshot.data['desativarInputsEBotoes'] === true ) {
          this.desativarInputsEBotoes = this.activedRoute.snapshot.data['desativarInputsEBotoes'];
      }
    } catch (e) {
      console.log(e.stack);
    }
  }

  ngOnInit() {
    this.getConsultas().then(([rsCombinada, rsConsulta, rsCredito, rsInsumo]) => {
      this.listaConsulta = rsConsulta.map(c => { return { consulta: c, range: [this.addRangeItem()] } });
      this.listaConsultaCombo = rsConsulta.map(c => new Consulta({ ...c }));
      this.listaConsultaCombinada = rsCombinada.map(c => { return { consulta: c, range: [this.addRangeItem()] } });
      this.listaConsultaCreditoCombo = rsCredito.map(c => new Consulta({ ...c }));
      this.listaConsultaCredito = rsCredito.map(c => { return { consulta: c, range: [this.addRangeItem()] } });
      this.listaInsumoConsultas = rsInsumo.map(c => { return { insumo: c, range: [this.addRangeItem()] } });

      this.getTabelaPreco();
    });
  }

  aguardar(milisegundos ){
    setTimeout(function(){
      this.exibirBotaoRefresh = true;
  },milisegundos);
  }

  addRangeItem(valor: string | number = '', min = 1, id = null) {
    if (typeof valor == 'number') {
      valor = Utils.numberToString(valor)
    }

    return new FormGroup({
      valorConsulta: new FormControl(valor, [Validators.required, UtilValidators.decimal, UtilValidators.decimalMin(0.01)]),
      min: new FormControl(min, [Validators.required]),
      id: new FormControl(id),
    });
  }

  async getTabelaPreco() {

    try {

      if (this.tabelaPadrao) {
        let result = await this.tabelaPrecoService.getTabelaPadrao();
        this.uuid = result.uuid;
      }

      if(this.uuid) {
        let t = await this.tabelaPrecoService.getTabelaPreco(this.uuid);
        this.form.patchValue({
          nome: t.nome,
          descricao: t.descricao,
          min: t.consumoMinimo != null ? Utils.numberToString(t.consumoMinimo) : '',
          intervalo: t.intervaloCobranca != null ? t.intervaloCobranca : '30'
        });

        this.setValores(t.listaValorConsulta, this.listaConsulta);
        this.setValores(t.listaValorConsultaCombinada, this.listaConsultaCombinada);
        this.setValores(t.listaValorConsultaCredito, this.listaConsultaCredito);
        this.setValoresInsumos(t.listaValorInsumoConsulta, this.listaInsumoConsultas);
        this.setValoresCombo(t.listaValorCombo);
      }

    } catch (error) {
      console.error(error);
      this.msgModal.openDialog('Erro ao carregar informações', '', 'Danger');
    }

  }

  setValores(de, para) {
    de.forEach(r => {
      let consulta = para.find(c => c.consulta.id == r.id);
      if (consulta) {
        consulta.cortesia = r.cortesia;
        consulta.range = r.listrange.map(item => this.addRangeItem(item.valor, item.rangeMin, item.id));
      }
    });
  }

  setValoresInsumos(de, para) {
    de.forEach(r => {
      let insumo = para.find(i => i.insumo.id == r.id);
      if (insumo) {
        insumo.cortesia = r.cortesia;
        insumo.range = r.listrange.map(item => this.addRangeItem(item.valor, item.rangeMin, item.id));
      }
    });
  }

  setValoresCombo(combo) {
    combo.forEach(c => {
      this.listaCombos.push({
        id: c.id || null,
        nome: c.nome,
        cortesia: c.cortesia,
        consultas: c.listaConsultas || [],
        range: c.listrange.map(item => this.addRangeItem(item.valor, item.rangeMin, item.id))
      });
    });
  }

  getConsultas(): Promise<any[]> {
    let rsCombinada = this.consultaService.listaConsultaCombinada();
    let rsConsulta = this.consultaService.listaConsulta();
    let rsCredito = this.ciacService.getListaConsultaCreditoSemInsumos();
    let rsInsumo = this.ciacService.getListaInsumosConsultas();
    return forkJoin([rsCombinada, rsConsulta, rsCredito, rsInsumo]).toPromise();
  }

  open(content) {

    this.modalForm = {
      consultas: [
        ...this.listaConsultaCombo.map(c => new Consulta({ ...c, checked: false })),
      ],
      credito: [
        ...this.listaConsultaCreditoCombo.map(c => new Consulta({ ...c, checked: false }))
      ],
      nome: new FormControl('', [Validators.required]),
    };

    this.modalService.open(content, { size: 'lg', ariaLabelledBy: 'Novo combo' })
      .result.then((result) => {
        if (result == 'ok') {
          let a = [];

          if(this.modalForm.consultas.filter(c => c.checked).length > 0) {
            this.modalForm.consultas.forEach(e => {
              if(e.checked == true) {
                a.push(e);
              }
            });
          }

          if(this.modalForm.credito.filter(c => c.checked).length > 0) {
            this.modalForm.credito.forEach(e => {
              if(e.checked == true) {
                a.push(e);
              }
            });
          }

          this.listaCombos.push({
            id: null,
            cortesia: false,
            // consultas: this.modalForm.consultas.filter(c => c.checked),
            consultas: a.filter(c => c.checked),
            nome: this.modalForm.nome.value, range: [this.addRangeItem()]
          });
        }
      });
  }

  removerCombo(index) {
    this.listaCombos = this.listaCombos.filter((c, i) => index != i);
    this.listaCombosCredito = this.listaCombosCredito.filter((c, i) => index != i);
  }

  errorValidate() {
    let errorCount = 0;

    this.listaConsulta.forEach(c => {

      if (!c.cortesia) {
        c.range.forEach(r => {
          r.controls.min.markAsTouched();
          r.controls.valorConsulta.markAsTouched();
          if (r.invalid) {
            errorCount++;
          }
        })
      }

    });

    this.listaConsultaCombinada.forEach(c => {

      if (!c.cortesia) {
        c.range.forEach(r => {
          r.controls.min.markAsTouched();
          r.controls.valorConsulta.markAsTouched();
          if (r.invalid) {
            errorCount++;
          }
        })
      }

    });

    this.listaCombos.forEach(c => {

      if (!c.cortesia) {
        c.range.forEach(r => {
          r.controls.min.markAsTouched();
          r.controls.valorConsulta.markAsTouched();
          if (r.invalid) {
            errorCount++;
          }
        })
      }

    });

    this.listaConsultaCredito.forEach(c => {

      if (!c.cortesia) {
        c.range.forEach(r => {
          r.controls.min.markAsTouched();
          r.controls.valorConsulta.markAsTouched();
          if (r.invalid) {
            errorCount++;
          }
        })
      }

    });

    this.listaInsumoConsultas.forEach(c => {

      if (!c.cortesia) {
        c.range.forEach(r => {
          r.controls.min.markAsTouched();
          if (r.invalid) {
            errorCount++;
          }
        })
      }
      
    });

    if (errorCount > 0 || this.form.invalid) {

      for (const k in this.form.controls) {
        if (this.form.controls.hasOwnProperty(k)) {
          this.form.controls[k].markAsTouched();
        }
      }
      this.msgModal.openDialog('Formulario inválido', 'Preencha todos os campos corretamente', 'danger');
      return true;
    } else {
      return false;
    }
  }

  formatRange(range) {
    let listrange = [];

    for (let i = 0; i < range.length; i++) {
      const min = range[i].controls.min.value;
      const value = Utils.stringToNumber(range[i].controls.valorConsulta.value);
      let max = null;
      if (i < range.length - 1) {
        max = range[i + 1].controls.min.value - 1;
      }

      if (range[i].controls.id && range[i].controls.id.value) {
        let id = range[i].controls.id.value;
        listrange.push({ min: min, precoPersonalizado: value, max: max, id: id });
      } else {
        listrange.push({ min: min, precoPersonalizado: value, max: max, id: range.id || null });
      }
    }
    return listrange;
  }

  formatJson() {

    let json = {
      listaValorCombo: [],
      listaValorConsulta: [],
      listaValorConsultaCombinada: [],
      listaValorConsultaCredito: [],
      listaValorInsumo: [],
      tabelaPadrao: this.tabelaPadrao,
      tabelaPreco: {
        uuid: this.uuid,
        intervaloCobranca: this.form.controls.intervalo.value,
        nome: this.form.controls.nome.value,
        consumoMinimo: Utils.stringToNumber(this.form.controls.min.value),
        descricao: this.form.controls.descricao.value,
      }
    };

    this.listaConsulta.forEach(c => {
      json.listaValorConsulta.push({ ...c.consulta, cortesia: c.cortesia, listrange: this.formatRange(c.range) });
    });

    this.listaConsultaCombinada.forEach(c => {
      json.listaValorConsultaCombinada.push({ ...c.consulta, cortesia: c.cortesia, listrange: this.formatRange(c.range) });
    });

    this.listaConsultaCredito.forEach(c => {
      json.listaValorConsultaCredito.push({ ...c.consulta, cortesia: c.cortesia, listrange: this.formatRange(c.range) });
    });

    this.listaInsumoConsultas.forEach(i => {
      json.listaValorInsumo.push({...i.insumo, cortesia: i.cortesia, listrange: this.formatRange(i.range)});
    });

    this.listaCombos.forEach(c => {
      json.listaValorCombo.push({ nome: c.nome, cortesia: c.cortesia, listaConsultas: c.consultas, listrange: this.formatRange(c.range) });
    });

    return json;
  }

  async confirmar() {

    if (this.errorValidate()) {
      return;
    }

    try {
      if (this.uuid) {
        await this.tabelaPrecoService.alterarTabelaPreco(this.formatJson());
      } else {
        await this.tabelaPrecoService.cadastrarTabelaPreco(this.formatJson());
      }
      this.router.navigate(['tabela-preco', 'listar']);
    } catch (error) {
      this.msgModal.open('Erro ao salvar informações', '', 'danger');
    }

  }

}
